import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/shared/ui';

type Props = { children: ReactNode };
type State = { hasError: boolean; error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.assign('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-4 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-destructive text-destructive-foreground">
            <span className="text-xl font-semibold">!</span>
          </div>
          <div>
            <h1 className="text-xl font-semibold tracking-tight">Algo deu errado</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Tente novamente. Se persistir, contate o suporte.
            </p>
          </div>
          <Button onClick={this.handleReset}>Voltar ao início</Button>
        </main>
      );
    }
    return this.props.children;
  }
}
